import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// DELETE /api/admin/forms/:id
//
// Destructive — show spinner, invalidate list on success. System forms
// (is_system=true) are rejected by 0028's trigger; the friendly message
// surfaces directly from the worker's HTTPException.
export function useDeleteForm() {
  const queryClient = useQueryClient();
  return useMutation<void, ApiClientError, string>({
    mutationFn: (id) =>
      apiFetch<void>(`/admin/forms/${id}`, { method: "DELETE" }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.adminForms.list() });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to delete form");
    },
  });
}
